var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHfaGraphLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 600.173 171.578",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lines",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "Border",
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_469_63",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.212743 0.078125H599.959V171.078H0.212743V0.078125Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0.212743 0.078125V-0.921875H-0.787257V0.078125H0.212743ZM0.212743 171.078H-0.787257V172.078H0.212743V171.078ZM0.212743 0.078125V1.07812H599.959V0.078125V-0.921875H0.212743V0.078125ZM599.959 171.078V170.078H0.212743V171.078V172.078H599.959V171.078ZM0.212743 171.078H1.21274V0.078125H0.212743H-0.787257V171.078H0.212743Z",
    fill: "var(--stroke-0, #F0F0F0)",
    mask: "url(#path-1-inside-1_469_63)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Line 1",
    d: "M0 171.078H600.173",
    stroke: "var(--stroke-0, #F0F0F0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 2",
    d: "M0 136.961H600.173",
    stroke: "var(--stroke-0, #F0F0F0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 3",
    d: "M0 102.848H600.173",
    stroke: "var(--stroke-0, #F0F0F0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 4",
    d: "M0 68.7305H600.173",
    stroke: "var(--stroke-0, #F0F0F0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 5",
    d: "M0 34.6172H600.173",
    stroke: "var(--stroke-0, #F0F0F0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 6",
    d: "M0 0.5H600.173",
    stroke: "var(--stroke-0, #F0F0F0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHfaGraphLines);
export default __webpack_public_path__ + "static/media/hfa_graph_lines.9161037ae902193ed47fdfe0efc2e75d.svg";
export { ForwardRef as ReactComponent };